export enum ClickEventNumbersEnum {
  AccountDetails = 0,
  PetDetails = 1,
  Dashboard = 2,
  Login = 3,
  FunctionUsage = 4,
  TileOpensLink = 5,
  TileOpensModal = 6,
  TileOpensLinkInModal = 7,
  Step4OptInPopupSubmit = 8,
  ClaimAccountOpened = 9,
}

export interface TrackingPayloadType {
  event: ClickEventNumbersEnum;
  details: string;
  emailAddress?: string;
  emailVerificationCode?: string;
}
